import GroupButtons from "../../../ui/button/groupButtons";
import BaseStep from "./baseStep";
import { EReadinessForLowerSellPrice } from "./types";

interface IOffersForClientStep {
  onPrevStep: () => void;
  onNexStep: () => void;
  onChange: (data: EReadinessForLowerSellPrice, key: "offersForClient") => void;
  isNextStepDisabled: boolean;
  data: EReadinessForLowerSellPrice | null;
}

const OffersForClientStep = ({
  onPrevStep,
  onNexStep,
  onChange,
  isNextStepDisabled,
  data,
}: IOffersForClientStep) => {
  const handleChange = (data: EReadinessForLowerSellPrice) => {
    onChange(data, "offersForClient");
  };

  return (
    <BaseStep
      prevStep={onPrevStep}
      nextStep={onNexStep}
      isNextStepDisabled={isNextStepDisabled}
      text="Какие предложения от покупателей риелтору передавать продавцу:"
    >
      <GroupButtons
        data={[
          {
            onClick: () => handleChange(EReadinessForLowerSellPrice.Any),
            label: "Любые",
            variant:
              data === EReadinessForLowerSellPrice.Any ? "dark" : "lightDark",
          },
          {
            onClick: () =>
              handleChange(EReadinessForLowerSellPrice.UpTo5Percent),
            label: "Торг не более 5%",
            variant:
              data === EReadinessForLowerSellPrice.UpTo5Percent
                ? "dark"
                : "lightDark",
          },
        ]}
      />
    </BaseStep>
  );
};

export default OffersForClientStep;
